import { fmtBudgetAmount } from "./projectFilters.js";

// Detail retains native project-currency semantics, unlike the CapEx lens.
export function recordAmount(value) {
  if (value == null || String(value).trim() === "") return null;
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
}

export function recordVariance(project) {
  const budget = recordAmount(project?.approvedBudget);
  const forecast = recordAmount(project?.forecastAtCompletion);
  return budget == null || forecast == null ? null : budget - forecast;
}

export function formatRecordAmount(value, currency, signed = false) {
  const amount = recordAmount(value);
  if (amount == null) return "Unknown";
  const sign = amount < 0 ? "−" : signed && amount > 0 ? "+" : "";
  return `${sign}${fmtBudgetAmount(Math.abs(amount), currency || "USD", { zeroAsMissing: false })}`;
}

export function recordIdentity(project, typeLabel) {
  return [project.locationRegion, project.locationName, project.locationAlias, project.locationId, typeLabel]
    .filter((value) => value != null && String(value).trim() !== "")
    .join(" · ");
}
